// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"937e36bc","428":"5b7bac27","604":"af09a423","647":"c0011e54","723":"c1e71258","783":"03f09506","787":"a54e5ad8","926":"8000fa4e"}[chunkId] + ".chunk.js";
};